import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { STATUS_COLOR } from '../../../common/statusTag'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { formatText, formatVal } from '../../../helpers/value'
import { EMPTY_VALUE } from '../../../utils/common'
import {
  COMPANY_INFO_KEYS,
  COMPANY_INFO_OPTIONS,
  INTERNATIONAL_INDEX,
} from './constants'
import classes from './index.module.scss'

const CLOSED = 'CLOSED'
const TERMINATED = 'TERMINATED'

export const BlockBasicInfo = ({ data, isDomesticSearch }) => {
  const {
    ENTERPRISE_STATUS,
    REGISTERED_ADDRESS,
    YEARS_OF_OPERATION,
    DATE_OF_REGISTRATION,
  } = COMPANY_INFO_KEYS
  const timezone = UseTimeZone()
  const locale = useSelector((state) => state.i18n.locale)

  // Render
  const renderTagStatus = (isDomesticSearch) => {
    if (!data?.activeStatusId && isDomesticSearch) {
      return EMPTY_VALUE
    }

    if (!data?.status && !isDomesticSearch) {
      return EMPTY_VALUE
    }

    return (
      <Element
        elementName="div"
        className={classes.tagStatus}
        style={{
          color: '#fff',
          backgroundColor:
            STATUS_COLOR[
              isDomesticSearch ? data.activeStatusId : data.status.toLowerCase()
            ] || '#3DA967',
        }}
      >
        {renderStatusText()}
      </Element>
    )
  }

  const renderStatusText = () => {
    if (isDomesticSearch) {
      return data.activeStatusName
    }

    return data.status === CLOSED ? TERMINATED : data.status
  }

  const getValue = (item, isInternational) => {
    if (!data) {
      return EMPTY_VALUE
    }

    if (!item.value) {
      return item.name
    }
    const valueByKey =
      data[isInternational ? item.valueInternational : item.value]
    if (item.value === DATE_OF_REGISTRATION) {
      return formatDateTime(valueByKey, FORMAT.DATE, locale, timezone)
    }

    if (item.value === YEARS_OF_OPERATION) {
      const value = formatVal(valueByKey, locale, false, 0)

      if (value === EMPTY_VALUE) {
        return value
      }

      return (
        <>
          {value} &nbsp;
          {valueByKey > 2 ? (
            <Translate value="domesticSearchPreview.YEARS" />
          ) : (
            <Translate value="domesticSearchPreview.YEAR" />
          )}
        </>
      )
    }

    if (item.value === REGISTERED_ADDRESS && !isDomesticSearch) {
      return formatText(
        Array.isArray(valueByKey) ? valueByKey.join(' ') : valueByKey,
      )
    }

    return formatText(valueByKey)
  }

  const renderInfo = (item, isInternational) => {
    return (
      <Element elementName="div" style={{ color: '#3A414B' }}>
        {getValue(item, isInternational)}
      </Element>
    )
  }

  return (
    <div className={classes.basicInfo}>
      {COMPANY_INFO_OPTIONS.map((item, index) => {
        const isInternational =
          INTERNATIONAL_INDEX.includes(index) && !isDomesticSearch
        return (
          <div key={index}>
            <Element
              elementName="div"
              className="fw600"
              style={{ color: '#191D25', marginBottom: 4 }}
            >
              <Translate
                value={isInternational ? item.nameInternational : item.name}
              />
            </Element>
            {item.value === ENTERPRISE_STATUS
              ? renderTagStatus(isDomesticSearch)
              : renderInfo(item, isInternational)}
          </div>
        )
      })}
    </div>
  )
}
